import React from 'react';
export function Hero() {
  return <section className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto pt-24 md:pt-36 pb-28 md:pb-40" data-id="element-35" data-mp="3q74h710ubfvn">
      <div className="max-w-5xl" data-id="element-36" data-mp="eiblf9qr6a3n">
        <h1 className="text-[2.9rem] leading-[1.08] md:text-[5.2rem] md:leading-[1.04]" data-id="element-37" data-mp="9ktdnmoh20x8">
          Energy for the life
          <br data-id="element-38" data-mp="4m8l89fgoljc" />
          <span className="italic" data-id="element-39" data-mp="4mrvd3yve5mt">you built.</span>
        </h1>
        <div className="mt-12 md:mt-16 md:ml-[38%] max-w-md" data-id="element-40" data-mp="129h6c3bjvskt">
          <p className="font-sans font-light text-lg text-graphite/80 leading-relaxed" data-id="element-41" data-mp="128pi5dka8x4k">
            Structured, premium wellness guidance for people who want results
            without chaos.
          </p>
          <a href="https://form.jotform.com/262155460714050" target="_blank" rel="noopener noreferrer" className="cta mt-10" data-id="element-42" data-mp="sde2mt11vlvr">
            Start the Conversation
          </a>
        </div>
      </div>
    </section>;
}